(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4093],{

/***/ 48004:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/roofing-calculator",
      function () {
        return __webpack_require__(3397);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 56130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CalculatorBlogs_Blog; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var index_esm = __webpack_require__(8193);
;// CONCATENATED MODULE: ./components/CalculatorBlogs/BlogCard.jsx




const BlogCard = (param)=>{
    let { question , answer  } = param;
    const [blogVisible, setBlogVisible] = (0,react.useState)(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex mb-[30px] pb-[30px] gap-[20px] border-b border-b-gray-300",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                onClick: ()=>blogVisible ? setBlogVisible(false) : setBlogVisible(true),
                className: "pt-[5px] text-[20px] md:text-[35px] w-fit cursor-pointer",
                children: blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlineMinus */.ywL, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* AiOutlinePlus */.Lfi, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "question text-[25px] md:text-[30px] mb-[20px] font-medium",
                        children: question
                    }),
                    blogVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "answer text-[16px] md:text-[18px] font-light text-gray-700",
                        children: answer
                    }) : ""
                ]
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/CalculatorBlogs/Blog.jsx



const Blog = (param)=>{
    let { heading , BlogData , width ="lg:w-[850px]"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-[100%] mx-auto md:w-[80%] ".concat(width),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[25px] md:text-[40px] text-center font-bold mb-14 mx-auto",
                children: heading
            }),
            BlogData.map((blog)=>{
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CalculatorBlogs_BlogCard, {
                    question: blog.question,
                    answer: blog.answer
                }, blog.id);
            })
        ]
    });
};
/* harmony default export */ var CalculatorBlogs_Blog = (Blog);


/***/ }),

/***/ 3397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ roofing_calculator; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./components/Tools/RoofingCalculator/RoofingCalc.jsx




const RoofingCalc = ()=>{
    // const UNIT_CONVERSIONS = {
    //    sqft: 1,
    //    sqm: 10.7639,
    //    sqyd: 9,
    //    sqin: 144,
    //    sqcm: 929.03,
    //    ft: 1,
    //    m: 3.28084,
    //    yd: 0.333333,
    //    in: 12,
    //    cm: 30.48,
    // };
    const [houseDimensions, setHouseDimensions] = (0,react.useState)({
        houseLength: "",
        houseWidth: "",
        houseArea: "",
        houseBaseUnit: "sqm"
    });
    const [roofPitch, setRoofPitch] = (0,react.useState)({
        pitchDegree: "",
        degreeCalculated: false,
        pitchPercent: "",
        percentCalculated: false,
        pitchRatio: "",
        ratioCalculated: false
    });
    const [roofCost, setRoofCost] = (0,react.useState)({
        roofArea: "",
        roofAreaUnit: "sqm",
        unitPrice: "",
        unitPriceBase: "sqm",
        roofTotalCost: ""
    });
    function handleAreaChange(event) {
        setHouseDimensions({
            ...houseDimensions,
            houseLength: "",
            houseWidth: "",
            houseArea: event.target.value
        });
    }
    (0,react.useEffect)(()=>{
        if (houseDimensions.houseWidth !== "" && houseDimensions.houseLength !== "") {
            setHouseDimensions({
                ...houseDimensions,
                houseArea: houseDimensions.houseLength * houseDimensions.houseWidth
            });
        }
    }, [
        houseDimensions.houseLength,
        houseDimensions.houseWidth
    ]);
    (0,react.useEffect)(()=>{
        if (roofPitch.pitchDegree !== "" && !roofPitch.degreeCalculated) {
            const pitchInRadians = roofPitch.pitchDegree * (Math.PI / 180);
            const pitchInPercentage = Math.tan(pitchInRadians) * 100;
            const pitchInRatio = "".concat((12 / (100 / (100 * Math.tan(roofPitch.pitchDegree * (Math.PI / 180))))).toFixed(3));
            setRoofPitch({
                ...roofPitch,
                pitchPercent: pitchInPercentage.toFixed(2),
                percentCalculated: true,
                pitchRatio: pitchInRatio,
                ratioCalculated: true
            });
        }
    }, [
        roofPitch.pitchDegree
    ]);
    //  useEffect(() => {
    //    if (roofPitch.pitchPercent !== '' && !roofPitch.percentCalculated) {
    //      const pitchInRadians = Math.atan(roofPitch.pitchPercent / 100);
    //      const pitchInDegree = pitchInRadians * (180 / Math.PI);
    //    //   const pitchInRatio = `1:${1 / Math.tan(pitchInRadians)}`;
    //      const pitchInRatio = `${(12/(100/(100* Math.tan(roofPitch.pitchDegree * (Math.PI/180))))).toFixed(3)}`;
    //      setRoofPitch({...roofPitch, pitchDegree:pitchInDegree.toFixed(2),degreeCalculated:true, pitchRatio:pitchInRatio, ratioCalculated:true})
    //    }
    //  }, [roofPitch.pitchPercent]);
    (0,react.useEffect)(()=>{
        if (roofPitch.pitchRatio !== "" && !roofPitch.ratioCalculated) {
            const pitchInRadians = Math.atan(roofPitch.pitchRatio / 12);
            const pitchInDegree = pitchInRadians * (180 / Math.PI);
            const pitchInPercentage = Math.tan(pitchInRadians) * 100;
            setRoofPitch({
                ...roofPitch,
                pitchDegree: pitchInDegree.toFixed(2),
                degreeCalculated: true,
                pitchPercent: pitchInPercentage.toFixed(2),
                percentCalculated: true
            });
        }
    }, [
        roofPitch.pitchRatio
    ]);
    function calculateRoofArea() {
        const pitchInRadians = roofPitch.pitchDegree * (Math.PI / 180);
        const totalRoofArea = houseDimensions.houseArea / Math.cos(pitchInRadians);
        // Convert to desired unit of measurement
        let roofAreaConverted;
        if (houseDimensions.houseBaseUnit === "sqm") {
            switch(roofCost.roofAreaUnit){
                case "sqm":
                    roofAreaConverted = totalRoofArea;
                    break;
                case "sqft":
                    roofAreaConverted = totalRoofArea * 10.7639;
                    break;
                case "sqyd":
                    roofAreaConverted = totalRoofArea * 1.19599;
                    break;
                case "sqin":
                    roofAreaConverted = totalRoofArea * 1550.0031;
                    break;
                case "sqcm":
                    roofAreaConverted = totalRoofArea * 10000;
                    break;
                default:
                    roofAreaConverted = totalRoofArea;
            }
        } else if (houseDimensions.houseBaseUnit === "sqft") {
            switch(roofCost.roofAreaUnit){
                case "sqm":
                    roofAreaConverted = totalRoofArea / 10.7639;
                    break;
                case "sqft":
                    roofAreaConverted = totalRoofArea;
                    break;
                case "sqyd":
                    roofAreaConverted = totalRoofArea / 9;
                    break;
                case "sqin":
                    roofAreaConverted = totalRoofArea * 144;
                    break;
                case "sqcm":
                    roofAreaConverted = totalRoofArea * 929.03;
                    break;
                default:
                    roofAreaConverted = totalRoofArea;
            }
        } else if (houseDimensions.houseBaseUnit === "sqyd") {
            switch(roofCost.roofAreaUnit){
                case "sqm":
                    roofAreaConverted = totalRoofArea / 1.19599;
                    break;
                case "sqft":
                    roofAreaConverted = totalRoofArea * 9;
                    break;
                case "sqyd":
                    roofAreaConverted = totalRoofArea;
                    break;
                case "sqin":
                    roofAreaConverted = totalRoofArea * 1296;
                    break;
                case "sqcm":
                    roofAreaConverted = totalRoofArea * 8361.2736;
                    break;
                default:
                    roofAreaConverted = totalRoofArea;
            }
        } else if (houseDimensions.houseBaseUnit === "sqin") {
            switch(roofCost.roofAreaUnit){
                case "sqm":
                    roofAreaConverted = totalRoofArea / 1550.0031;
                    break;
                case "sqft":
                    roofAreaConverted = totalRoofArea / 144;
                    break;
                case "sqyd":
                    roofAreaConverted = totalRoofArea / 1296;
                    break;
                case "sqin":
                    roofAreaConverted = totalRoofArea;
                    break;
                case "sqcm":
                    roofAreaConverted = totalRoofArea * 6.4516;
                    break;
                default:
                    roofAreaConverted = totalRoofArea;
            }
        } else if (houseDimensions.houseBaseUnit === "sqcm") {
            switch(roofCost.roofAreaUnit){
                case "sqm":
                    roofAreaConverted = totalRoofArea / 10000;
                    break;
                case "sqft":
                    roofAreaConverted = totalRoofArea / 929.03;
                    break;
                case "sqyd":
                    roofAreaConverted = totalRoofArea / 8361.2736;
                    break;
                case "sqin":
                    roofAreaConverted = totalRoofArea / 6.4516;
                    break;
                case "sqcm":
                    roofAreaConverted = totalRoofArea;
                    break;
                default:
                    roofAreaConverted = totalRoofArea;
            }
        }
        return roofAreaConverted;
    }
    (0,react.useEffect)(()=>{
        if (houseDimensions.houseArea !== "" && roofPitch.pitchDegree !== "") {
            const totalRoofArea = calculateRoofArea();
            setRoofCost({
                ...roofCost,
                roofArea: totalRoofArea.toFixed(2)
            });
        }
    }, [
        houseDimensions.houseArea,
        roofPitch.pitchDegree,
        roofCost.roofAreaUnit
    ]);
    // useEffect(()=>{
    //    if(roofCost.roofArea !== ''){
    //       const totalCost = roofCost.roofArea * roofCost.unitPrice;
    //       setRoofCost({...roofCost, roofTotalCost:totalCost.toFixed(2)})
    //    }
    // },[roofCost.unitPrice, roofCost.unitPriceBase])
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full max-w-[1000px] bg-gray-200 mx-auto py-[30px] px-[5px] md:px-[30px] rounded-sm drop-shadow-lg flex flex-col lg:flex-row gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "max-w-[100%] lg:w-[50%] h-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-col gap-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-gray-500 flex flex-col gap-[2px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]",
                                    children: "House Dimensions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "House Length"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: houseDimensions.houseLength,
                                                    onChange: (e)=>{
                                                        setHouseDimensions({
                                                            ...houseDimensions,
                                                            houseLength: e.target.value
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: houseDimensions.houseBaseUnit,
                                                    onChange: (e)=>{
                                                        setHouseDimensions({
                                                            ...houseDimensions,
                                                            houseBaseUnit: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqm",
                                                            className: "bg-white",
                                                            children: "m \xa0 \xa0\xa0metres"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqft",
                                                            className: "bg-white",
                                                            children: "ft \xa0 \xa0\xa0\xa0\xa0feet"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqyd",
                                                            className: "bg-white",
                                                            children: "yd \xa0 \xa0\xa0yards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqin",
                                                            className: "bg-white",
                                                            children: "in \xa0 \xa0\xa0\xa0inches"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqcm",
                                                            className: "bg-white",
                                                            children: "cm \xa0 cm"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "House Width"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: houseDimensions.houseWidth,
                                                    onChange: (e)=>{
                                                        setHouseDimensions({
                                                            ...houseDimensions,
                                                            houseWidth: e.target.value
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: houseDimensions.houseBaseUnit,
                                                    onChange: (e)=>{
                                                        setHouseDimensions({
                                                            ...houseDimensions,
                                                            houseBaseUnit: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqm",
                                                            className: "bg-white",
                                                            children: "m \xa0 \xa0\xa0metres"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqft",
                                                            className: "bg-white",
                                                            children: "ft \xa0 \xa0\xa0\xa0\xa0feet"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqyd",
                                                            className: "bg-white",
                                                            children: "yd \xa0 \xa0\xa0yards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqin",
                                                            className: "bg-white",
                                                            children: "in \xa0 \xa0\xa0\xa0inches"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqcm",
                                                            className: "bg-white",
                                                            children: "cm \xa0 cm"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "House Base Area"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: houseDimensions.houseArea,
                                                    onChange: handleAreaChange
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: houseDimensions.houseBaseUnit,
                                                    onChange: (e)=>{
                                                        setHouseDimensions({
                                                            ...houseDimensions,
                                                            houseBaseUnit: e.target.value
                                                        });
                                                        setRoofCost({
                                                            ...roofCost,
                                                            roofAreaUnit: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqm",
                                                            className: "bg-white",
                                                            children: "m\xb2 \xa0\xa0square metres"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqft",
                                                            className: "bg-white",
                                                            children: "ft\xb2 \xa0\xa0\xa0\xa0square feet"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqyd",
                                                            className: "bg-white",
                                                            children: "yd\xb2 \xa0\xa0square yards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqin",
                                                            className: "bg-white",
                                                            children: "in\xb2 \xa0\xa0\xa0square inches"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqcm",
                                                            className: "bg-white",
                                                            children: "cm\xb2 square cm"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-gray-500 flex flex-col gap-[2px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]",
                                    children: "Roof Pitch"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "Roof Pitch"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: roofPitch.pitchDegree,
                                                    onChange: (e)=>{
                                                        setRoofPitch({
                                                            ...roofPitch,
                                                            pitchDegree: e.target.value,
                                                            degreeCalculated: false
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    children: "deg"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "Roof Pitch(x:12)"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: roofPitch.pitchRatio,
                                                    onChange: (e)=>{
                                                        setRoofPitch({
                                                            ...roofPitch,
                                                            pitchRatio: e.target.value,
                                                            ratioCalculated: false
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    children: ":12"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-gray-500 flex flex-col gap-[2px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "text-gray-200 bg-violet-500 font-medium text-[18px] border-b-2 py-[10px] text-center mb-[10px]",
                                    children: "Roof Cost"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "Roof area"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: roofCost.roofArea,
                                                    onChange: (e)=>{
                                                        setRoofCost({
                                                            ...roofCost,
                                                            roofArea: e.target.value
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: roofCost.roofAreaUnit,
                                                    onChange: (e)=>{
                                                        setRoofCost({
                                                            ...roofCost,
                                                            roofAreaUnit: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqm",
                                                            className: "bg-white",
                                                            children: "m\xb2 \xa0\xa0square metres"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqft",
                                                            className: "bg-white",
                                                            children: "ft\xb2 \xa0\xa0\xa0\xa0square feet"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqyd",
                                                            className: "bg-white",
                                                            children: "yd\xb2 \xa0\xa0square yards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqin",
                                                            className: "bg-white",
                                                            children: "in\xb2 \xa0\xa0\xa0square inches"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqcm",
                                                            className: "bg-white",
                                                            children: "cm\xb2 square cm"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "Unit Price"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    value: roofCost.unitPrice,
                                                    onChange: (e)=>{
                                                        setRoofCost({
                                                            ...roofCost,
                                                            unitPrice: e.target.value
                                                        });
                                                    }
                                                }),
                                                "$/",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none rounded-md h-[50px] w-[55px]",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    value: roofCost.roofAreaUnit,
                                                    onChange: (e)=>{
                                                        setRoofCost({
                                                            ...roofCost,
                                                            roofAreaUnit: e.target.value
                                                        });
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqm",
                                                            className: "bg-white",
                                                            children: "m\xb2 \xa0\xa0square metres"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqft",
                                                            className: "bg-white",
                                                            children: "ft\xb2 \xa0\xa0\xa0\xa0square feet"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqyd",
                                                            className: "bg-white",
                                                            children: "yd\xb2 \xa0\xa0square yards"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqin",
                                                            className: "bg-white",
                                                            children: "in\xb2 \xa0\xa0\xa0square inches"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                            value: "sqcm",
                                                            className: "bg-white",
                                                            children: "cm\xb2 square cm"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between items-center rounded-sm",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-gray-600 font-medium text-[16px] w-[40%]",
                                            children: "Total cost"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center justify-between w-[60%] border border-gray-500",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    className: "bg-transparent border-none drop-shadow-none text-gray-600 outline-none py-2 px-3 w-full h-[50px]",
                                                    id: "",
                                                    name: "",
                                                    type: "text",
                                                    placeholder: "",
                                                    required: true,
                                                    readOnly: true,
                                                    value: (roofCost.roofArea * roofCost.unitPrice).toFixed(2)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "border-none bg-transparent text-gray-600 outline-none h-[50px] w-[55px] grid place-items-center",
                                                    id: "",
                                                    name: "",
                                                    required: true,
                                                    children: "$"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-[100%] lg:w-[50%] grid place-items-center py-[30px] gap-[20px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                        className: "text-center text-gray-500 text-[50px] uppercase font-light",
                        children: [
                            "Roofing ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " Calculator"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        width: "20",
                        height: "20",
                        className: "w-full mx-auto",
                        loading: "lazy",
                        src: "".concat(constants.BASE_ASSETS_URL, "/house.png"),
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-center text-gray-500 text-[25px] font-light",
                        children: "Calculate Roof Area by providing House area and Roof Pitch."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var RoofingCalculator_RoofingCalc = (RoofingCalc);

// EXTERNAL MODULE: ./components/CalculatorBlogs/Blog.jsx + 1 modules
var Blog = __webpack_require__(56130);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/calculators/roofing-calculator/index.jsx





const BlogData = [
    {
        id: 1,
        question: "What is a roofing calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "A roofing calculator is a tool used to calculate the pitch of a roof. It takes various inputs such as degrees, percentage, and ratio, and automatically calculates the remaining values based on the input provided."
            })
        })
    },
    {
        id: 2,
        question: "How accurate is a roofing calculator?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "A roofing calculator is highly accurate and reliable as long as the input values are entered correctly. However, it is important to note that the tool is only as accurate as the measurements provided."
            })
        })
    },
    {
        id: 3,
        question: "Can a roofing calculator be used for all types of roofs?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, a roofing calculator can be used for all types of roofs, regardless of their size or shape. It is a versatile tool that can be used by homeowners, contractors, architects, and engineers."
            })
        })
    },
    {
        id: 4,
        question: "Is a roofing calculator easy to use?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, a roofing calculator is easy to use, even for those who are not familiar with roofing terms and measurements. The user-friendly interface and clear instructions make it easy for anyone to use the tool."
            })
        })
    },
    {
        id: 5,
        question: "Is a roofing calculator free?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "There are many free roofing calculators available online, including the one provided here. However, some calculators may require payment or a subscription to access additional features or services."
            })
        })
    },
    {
        id: 6,
        question: "Do I need to provide all inputs for the roofing calculator to work?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "No, you only need to provide two input values (base area and roof pitch) for the roofing calculator to automatically calculate the remaining values."
            })
        })
    },
    {
        id: 7,
        question: "Can a roofing calculator be used for both residential and commercial roofs?",
        answer: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex flex-col gap-[20px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Yes, a roofing calculator can be used for both residential and commercial roofs. The tool is versatile and can be used for any type of roof regardless of size or shape."
            })
        })
    }
];
const RoofingCalculator = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto w-full lg:px-[100px] py-[20px] sm:py-[100px] flex flex-col items-center justify-between gap-[50px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                charSet: "utf-8"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: "Roofing Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.region",
                                content: "IN"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "geo.position",
                                content: "22.351115;78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "ICBM",
                                content: "22.351115, 78.667743"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "author",
                                content: "BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "publisher",
                                content: "BoloSign "
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "robots",
                                content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: "https://www.bolosign.com/calculators/roofing-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: "https://www.bolosign.com/calculators/roofing-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: "Roofing Calculator | Calculators | BoloSign"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:card",
                                content: "summary_large_image"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:domain",
                                content: "https://bolosign.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "twitter:url",
                                content: "https://www.bolosign.com/calculators/roofing-calculator/"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: "BoloSign helps you take signatures easily in pdfs, docs, forms and templates within mintues!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:image",
                                content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute top-0 z-[-500] left-0 w-full bg-violet-500 h-[500px]"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-[15px] sm:gap-[30px] w-full xl:w-[80%] text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-bold text-[45px] xl:text-[60px] leading-[45px] xl:leading-[60px] text-white",
                                children: "Roofing Calculator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white text-[16px] lg:text-[18px] font-light",
                                children: "Roofing calculator is a helpful tool designed to simplify the process of determining the roof area. With two input fields for base area and pitch ratio, the calculator automatically calculates the remaining values. The calculator is user-friendly and straightforward, making it ideal for both homeowners and professionals alike.Our roofing calculator can save you time and effort while ensuring you get accurate pitch measurements every time."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RoofingCalculator_RoofingCalc, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Blog/* default */.Z, {
                heading: "Roofing Calculator FAQs",
                BlogData: BlogData
            })
        ]
    });
};
/* harmony default export */ var roofing_calculator = (RoofingCalculator);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,9774,2888,179], function() { return __webpack_exec__(48004); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);